import Text from "../components/Text";
import styles from "./Legal.module.css";

export default function Impressum() {
    return (
        <div class={styles.page}>
            <div class={styles.heroBand}>
                <div class={styles.heroInner}>
                    <span class={styles.eyebrow}><Text val="IMPRESSUM_EYEBROW" /></span>
                    <h1 class={styles.heroTitle}><Text val="IMPRESSUM_TITLE" /></h1>
                    <p class={styles.heroSubtitle}><Text val="IMPRESSUM_SUBTITLE" /></p>
                </div>
            </div>

            <main class={styles.content}>
                <section class={styles.section}>
                    <h2><Text val="IMPRESSUM_RESP_TITLE" /></h2>
                    <div class={styles.card}>
                        <p>
                            Elias Traunbauer<br />
                            Wasserwerkstraße 2<br />
                            4052 Ansfelden<br />
                            Oberösterreich, Österreich
                        </p>
                        <p>
                            <Text val="IMPRESSUM_EMAIL_LABEL" />: <a href="mailto:elias.traunbauer@gmx.at">elias.traunbauer@gmx.at</a>
                        </p>
                    </div>
                </section>

                <section class={styles.section}>
                    <h2><Text val="IMPRESSUM_NATURE_TITLE" /></h2>
                    <p><Text val="IMPRESSUM_NATURE_BODY" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="IMPRESSUM_LIABILITY_TITLE" /></h2>
                    <p><Text val="IMPRESSUM_LIABILITY_BODY" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="IMPRESSUM_DISPUTE_TITLE" /></h2>
                    <p><Text val="IMPRESSUM_DISPUTE_BODY" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="IMPRESSUM_PRIVACY_TITLE" /></h2>
                    <p>
                        <Text val="IMPRESSUM_PRIVACY_BODY" /> <a href="/datenschutz"><Text val="IMPRESSUM_PRIVACY_LINK" /></a>
                    </p>
                </section>
            </main>
        </div>
    );
}
